import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
import Studies from "../components/Sections/Studies";
import Tourism from "../components/Sections/Tourism";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"

export default function Landing() {
  return (
    <>
      <TopNavbar />
      <Header />
      <Services />
      <Studies />
      <Tourism />
      <Contact />
      <Footer />
    </>
  );
}
